import browserHydrateFunction from './browser-hydrate-function';
export const replaceHydrateFunction = browserHydrateFunction;

export { wrapPageElement, wrapRootElement } from './gatsby-ssr';